import { useMutation, useQueryClient } from '@tanstack/react-query';
import { AccessRequestTemplatesApiCreateAccessRequestTemplateRequest } from '@client-app-sdk';
import useAccessRequestTemplatesApi from './use-access-request-templates-api';
import { BASE_QUERY_KEY } from '@client-app-sdk/utils/constants';

export default function useCreateAccessRequestTemplate() {
  const api = useAccessRequestTemplatesApi();
  const queryClient = useQueryClient();

  const {
    mutate: createRequestTemplate,
    mutateAsync: createRequestTemplateAsync,
    ...rest
  } = useMutation(
    async (payload: AccessRequestTemplatesApiCreateAccessRequestTemplateRequest) => {
      const res = await api.createAccessRequestTemplate(payload);
      return res;
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: [BASE_QUERY_KEY] });
      },
    },
  );
  return {
    createRequestTemplate,
    createRequestTemplateAsync,
    ...rest,
  };
}
